<h2>about leon.</h2>
<p class="about">Jahrgang 1995. Webentwickler aus dem kleinen beschaulichen 
    Kreis Neuburg-Schrobenhausen. Seit Geburt an im Neuburger Volkstheater e.V. 
    und von 2017 - 2024 Vorstandsmitglied. Meine erste Homepage entstand 2012 – 
    Beweise hierfür wurden vernichtet. Seit 2016 stolzer Katzenpapa – Rasse: rot – 
    Herkunft: Kroatische Straße. Zustand der Wohnung: werdender Jungel.</p>
